import React, { useState, useEffect } from 'react';
import { createContextHook } from 'use-context-hook';
import jobService from '../services/jobService';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from './authContext';

const context = {};

export const JobLeadsContext = createContextHook(context);

export function JobLeadsContextProvider({ children }) {
  const [jobName, setJobName] = useState('');
  const [searchQuery, setSearchQuery] = useState(null);

  const { fetch } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
  }));

  const { leads_data, leads_loading } = jobService.GetAllJobLeads(searchQuery, fetch);
  
  useEffect(() => {
    if (leads_data?.data) {
      const name = leads_data?.job?.name;
      if (name) {
        setJobName(name);
      }
    }
  }, [leads_data]);

  const updateSearchQuery = newQuery => {
    setSearchQuery(newQuery);
  };

  const value = {
    leadsData: leads_data,
    leadsLoading: leads_loading,
    jobName,
    updateSearchQuery,
  };

  return <JobLeadsContext.Provider value={value}>{children}</JobLeadsContext.Provider>;
}
